import { __rest } from "tslib";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Text, useDebounce } from '@as/cotopaxi';
import { LinkButton, Stack } from '@yonderland/andes-react';
import { useEffect, useRef, useState, useCallback } from 'react';
import { DELAY } from '../../constants/GeneralConstants';
import { generateTestId } from '../../util/TestUtil';
export const TruncatedText = (_a) => {
    var { content, readLessText, readMoreText, lineClamp = 1, testId = 'truncated-text' } = _a, textProps = __rest(_a, ["content", "readLessText", "readMoreText", "lineClamp", "testId"]);
    const [isTextTruncated, setIsTextTruncated] = useState(false);
    const [isExpanded, setIsExpanded] = useState(false);
    const textRef = useRef();
    const showToggle = isTextTruncated || isExpanded;
    const updateReadMoreBtnState = useCallback(() => {
        if (!textRef.current || isExpanded) {
            return;
        }
        const _isTextTruncated = textRef.current.offsetHeight !== textRef.current.scrollHeight;
        if (_isTextTruncated !== isTextTruncated) {
            setIsTextTruncated(_isTextTruncated);
        }
    }, [textRef, isTextTruncated, isExpanded]);
    const handleResize = useDebounce(updateReadMoreBtnState, DELAY.DELAY_100);
    useEffect(() => {
        updateReadMoreBtnState();
    }, [isTextTruncated, isExpanded]);
    useEffect(() => {
        window.addEventListener('resize', handleResize);
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, [updateReadMoreBtnState, handleResize, isExpanded]);
    const textLineClamp = typeof lineClamp === 'number'
        ? lineClamp
        : Object.assign(Object.assign({}, lineClamp), { withGradient: lineClamp.withGradient && isTextTruncated });
    return (_jsxs(Stack, { direction: "col", gap: "4", testId: testId, children: [_jsx(Text, Object.assign({}, textProps, { innerRef: textRef, lineClamp: isExpanded ? undefined : textLineClamp, children: content })), showToggle && (_jsx(LinkButton, { onClick: () => setIsExpanded(prev => !prev), variant: "secondary", testId: generateTestId({ testId, suffix: isExpanded ? 'read-less' : 'read-more' }), children: isExpanded ? readLessText : readMoreText }))] }));
};
